export const API_BASE_URL = 'https://partner.designsbydmi.com/api';
export const CMS_BASE_URL = `${API_BASE_URL}/cms`;

export const API_ENDPOINTS = {
  SERVICES: (category: string) => `${CMS_BASE_URL}/services/${category}`,
  SERVICE_BY_SLUG: (slug: string) => `${CMS_BASE_URL}/services/slug/${slug}`,
  PORTFOLIO: (category: string) => `${CMS_BASE_URL}/portfolio/${category}`,
  PORTFOLIO_BY_SERVICE: (slug: string) => `${CMS_BASE_URL}/portfolio/service/${slug}`,
  CONTENT: (key: string) => `${CMS_BASE_URL}/content/${key}`,
  ALL_CMS: `${CMS_BASE_URL}/all`,
  CONTACT_FORM: `${API_BASE_URL}/contact-form`,
};
